import $ from 'jquery/src/jquery';

$(document).ready(function($) {
    function textImageBlockHandler() {
        $('.textImageBlock').each(function (index, element) {
            const $element = $(element);
            const $title = $element.find('h2');
            const $textCol = $element.find('.textImageBlock__textInner');
            if ( window.outerWidth >= 640 ) {
                $title.prependTo($textCol);
            } else {
                $title.prependTo($element);
            }
        });
    }
    textImageBlockHandler();
    $(window).resize(textImageBlockHandler);
})